module.exports = __webpack_public_path__ + "static/img/5.bb51c8c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/sp/5.png
// module id = wAIh
// module chunks = 0